module.exports = __webpack_public_path__ + "media/components/app-store/static/s10-db0798a4b9130fed18b560fd97c54fbc.jpg";